export const findFocusable = element => {
  if (!element) {
    return null
  }
  return element.querySelectorAll(`a[href],
                                     area[href],
                                     input:not([disabled]),
                                     select:not([disabled]),
                                     textarea:not([disabled]),
                                     button:not([disabled]),
                                     iframe,
                                     object,
                                     embed,
                                     *[tabindex],
                                     *[contenteditable]`)
}

export function focusFirst(el) {
  const focusable = findFocusable(el)

  if (focusable && focusable.length > 0) {
    focusable[0].focus()
  }
}

let onKeyDown

const mounted = (el, { value = true }) => {
  if (value) {
    console.log('trap-focus-mounted')

    onKeyDown = event => {
      if (event.key === 'Tab') {
        const focusable = findFocusable(el)
        if (focusable && focusable.length > 0) {
          const firstFocusable = focusable[0]
          const lastFocusable = focusable[focusable.length - 1]
          if (event.target === firstFocusable && event.shiftKey) {
            event.preventDefault()
            lastFocusable.focus()
          } else if (event.target === lastFocusable && !event.shiftKey) {
            event.preventDefault()
            firstFocusable.focus()
          }
        }
      }
    }
    el.addEventListener('keydown', onKeyDown)
  }
}

const unmounted = el => {
  el.removeEventListener('keydown', onKeyDown)
}

export default { mounted, unmounted }
